import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getCarrierDetailFetchSuccess,
  getCarrierDetailFetchFailure,
  createCarrierDetailFetchSuccess,
  createCarrierDetailFetchFailure,
  updateCarrierDetailFetchSuccess,
  updateCarrierDetailFetchFailure,
  deleteCarrierDetailFetchSuccess,
  deleteCarrierDetailFetchFailure,
} from './reducer';
import { CarrierDetailResType } from 'src/types/carrierDetail';
import { CarrierType } from 'src/types/carrier';
import translate from '@translate';

const getCarrierDetailFetchRequest = async (id: string) => {
  const res = await api('get', `api/secure/carriers/${id}`);
  return res.data;
};

function* getCarrierDetailFetch(action: { type: string; payload: string }) {
  try {
    const response: CarrierDetailResType = yield call((): any => getCarrierDetailFetchRequest(action.payload));
    yield put(getCarrierDetailFetchSuccess(response));
  } catch (error) {
    yield put(getCarrierDetailFetchFailure({ error }));
  }
}

export function* getCarrierDetailFetchWatch() {
  yield takeEvery('carrierDetail/getCarrierDetailFetch', getCarrierDetailFetch);
}

const createCarrierDetailFetchRequest = async (data: CarrierType) => {
  const res = await api('post', 'api/secure/carriers', data);
  return res.data;
};

function* createCarrierDetailFetch(action: { type: string; payload: CarrierType }) {
  try {
    const response: CarrierDetailResType = yield call((): any => createCarrierDetailFetchRequest(action.payload));
    yield put(
      createCarrierDetailFetchSuccess({
        ...response,
        messageSuccess: { title: translate('carrierDetail.message.carrierCreated') },
      })
    );
  } catch (error) {
    yield put(createCarrierDetailFetchFailure({ error }));
  }
}

export function* createCarrierDetailFetchWatch() {
  yield takeEvery('carrierDetail/createCarrierDetailFetch', createCarrierDetailFetch);
}

const updateCarrierDetailFetchRequest = async (params: { id: string; data: CarrierType }) => {
  const res = await api('put', `api/secure/carriers/${params.id}`, params.data);
  return res.data;
};

function* updateCarrierDetailFetch(action: { type: string; payload: { id: string; data: CarrierType } }) {
  try {
    const response: CarrierDetailResType = yield call((): any => updateCarrierDetailFetchRequest(action.payload));
    yield put(
      updateCarrierDetailFetchSuccess({
        ...response,
        messageSuccess: { title: translate('carrierDetail.message.carrierUpdated') },
      })
    );
  } catch (error) {
    yield put(updateCarrierDetailFetchFailure({ error }));
  }
}

export function* updateCarrierDetailFetchWatch() {
  yield takeEvery('carrierDetail/updateCarrierDetailFetch', updateCarrierDetailFetch);
}

const deleteCarrierDetailFetchRequest = async (id: string) => {
  const res = await api('delete', `api/secure/carriers/${id}`);
  return res.data;
};

function* deleteCarrierDetailFetch(action: { type: string; payload: string }) {
  try {
    const response: CarrierDetailResType = yield call((): any => deleteCarrierDetailFetchRequest(action.payload));
    yield put(
      deleteCarrierDetailFetchSuccess({
        ...response,
        messageSuccess: { title: translate('carrierDetail.message.carrierDeleted') },
      })
    );
  } catch (error) {
    yield put(deleteCarrierDetailFetchFailure({ error }));
  }
}

export function* deleteCarrierDetailFetchWatch() {
  yield takeEvery('carrierDetail/deleteCarrierDetailFetch', deleteCarrierDetailFetch);
}

